lpcms.infinitescroll = {};
lpcms.infinitescroll.add = function(url,selector, windowsize, scrollpercent_top, scrollpercent_bottom, per_page, onload_top, onload_bottom) {
	$(window).off('wheel scroll').on('wheel scroll',function(e) {
		var scroll_percent = (($(window).scrollTop()/($(document).height()-$(window).height()))*100);
		if (scroll_percent > scrollpercent_bottom && !lpcms.infinitescroll.is_loading_bottom) {
			lpcms.infinitescroll.is_loading_bottom = true;
			lpcms.infinitescroll.currentpage++;
			axios.get(url+(url.match(/\?/) ? '&' : '?')+'page='+lpcms.infinitescroll.currentpage+'&via_scroll=true').then(function(d) {
				var html = $(d.data);
				html.insertAfter($(selector+':last'));
				// $(selector+'[data-page='+(lpcms.infinitescroll.currentpage-windowsize-1)+']').remove();
				onload_bottom(html);
				if ($(d.data).filter(selector).length >= per_page) {
					setTimeout(function() {
						lpcms.infinitescroll.is_loading_top = false;
						lpcms.infinitescroll.is_loading_bottom = false;
					}, 1000);
				}
			});
		}/* else if (scroll_percent < scrollpercent_top && lpcms.infinitescroll.currentpage > windowsize && !lpcms.infinitescroll.is_loading_top) {
			lpcms.infinitescroll.is_loading_top = true;
			lpcms.infinitescroll.currentpage--;
			$.get(url+'?page='+(lpcms.infinitescroll.currentpage - windowsize)+'&via_scroll=true', function(d) {
				var html = $(d);
				html.insertBefore($(selector+':first'));
				$(selector+'[data-page='+(lpcms.infinitescroll.currentpage+1)+']').remove();
				onload_top(html);
				if ((lpcms.infinitescroll.currentpage - windowsize) > 1) {
					setTimeout(function() {
						lpcms.infinitescroll.is_loading_top = false;
						lpcms.infinitescroll.is_loading_bottom = false;
					}, 1000);
				}
			});
		}*/
	});
};
lpcms.get_accountdata = function() {
	axios.get('/profile/getData').then(function(response) {
		var d = response.data;
		if (d) {
			if (d.unread_msgs > 0 && document.location.pathname != "/mailer") {
				$('#siteheader-navi-btn-mail .badge, #mobile-mainmenu-linklist-mailer .badge, #siteheader-mobile .badge-info-red').text(d.unread_msgs).show();
			} else {
				$('#siteheader-navi-btn-mail .badge, #mobile-mainmenu-linklist-mailer .badge, #siteheader-mobile .badge-info-red').hide();
			}
			if (d.coins) {
				$('#siteheader-navi-menu-profile-accountinfos .coins span, #mobile-mainmenu-accountinfos .coins span').text(d.coins.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."));
			}
		}
		window.Laravel.user.credits = d.coins;
		setTimeout(function() {
			lpcms.get_accountdata();
		}, 5000);
	});
};
lpcms.premium = {};
lpcms.premium.like_post = (btn) => {
	var clickedbtn = $(btn);
	if (lpcms.premium.hasSubscription) {
		return axios.post('/lovers/'+clickedbtn.data('postid')+'/toggleLike').then((r) => {
			var data = r.data;
			var targets = $('.lvrs__postinteractives-likebtn[data-postid='+clickedbtn.data('postid')+']');
			var datatargets = $('[data-postid='+clickedbtn.data('postid')+']');
			if (data.liked) {
				$(targets).addClass('active');
				datatargets.data('liked', 'true');
			} else {
				$(targets).removeClass('active');
				datatargets.data('liked', 'false');
			}
			$(targets).find('span').text(data.likes+' '+(data.likes != 1 ? Laravel.lang.common.likes : Laravel.lang.common.like));
			datatargets.data('likecount', data.likes);
			return r;
		});
	} else {
		lpcms.premium.clicked_but_not_subscribed();
	}
};
lpcms.premium.addLightbox = function(src) {
	$('a', src).featherlightGallery({
		nextIcon: '	&#8250;',
		previousIcon: '	&#8249;',
		targetAttr: 'data-lightboxcontent',
		afterContent: function() {
			lpcms.premium.addLightboxBottomData($('.featherlight-content', this.$instance), $(this.$currentTarget).parent());
		}
	});
}
lpcms.premium.addLightboxBottomData = function(lightbox, srcelem) {
	$(lightbox).find('video,img').off('contextmenu').on('contextmenu', function(e) {
		e.preventDefault();
		return false;
	}).off('dragstart').on('dragstart', function(e) {
		e.preventDefault();
		return false;
	});
	$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-comments span', lightbox).text($(srcelem).data('commentcount')+' '+($(srcelem).data('commentcount') != 1 ? Laravel.lang.common.comments : Laravel.lang.common.comment));
	$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-comments', lightbox).off('click').on('click', function() {
		$.featherlight.close();
		if ($('.lvrs__grid').length > 0) {
			lpcms.load_via_ajax('/lovers/'+$(srcelem).data('postid')+'/view?frompage='+lpcms.premium.currentpage+'&source='+lpcms.premium.mediatype+'&frompost='+$(srcelem).data('postid')).then(function() { document.location.hash = 'post-'+$(srcelem).data('postid')+'-comments'; });
		} else {
			$("html, body").animate({ scrollTop: $('#lvrs__post-'+$(srcelem).data('postid')+' .lvrs__postinteractives').position().top-50 }, "slow");
		}
	});

	$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-likebtn span', lightbox).text($(srcelem).data('likecount')+' '+($(srcelem).data('likecount') != 1 ? Laravel.lang.common.likes : Laravel.lang.common.like));
	$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-likebtn', lightbox).attr('data-postid', $(srcelem).data('postid')).data('postid', $(srcelem).data('postid')).off('click').on('click', function() {
		lpcms.premium.like_post(this).then(function(r) {
			$(srcelem).data('likecount', r.data.likes);
			$(srcelem).data('liked', r.data.liked);
		});
	});

	if ($(srcelem).data('liked')) {
		$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-likebtn', lightbox).addClass('active');
	} else {
		$('.lightbox-bottom .lvrs__postinteractives .lvrs__postinteractives-likebtn', lightbox).removeClass('active');
	}
	lpcms.premium.parsePostMedia(lightbox);
};
lpcms.premium.players = [];
lpcms.premium.fixVideoLayout = () => {
	for (var p in lpcms.premium.players) {
		var aspectratio = lpcms.premium.players[p].videoHeight()/lpcms.premium.players[p].videoWidth();
		if ($(window).width()*aspectratio < (window.innerHeight-68)) {
			$(lpcms.premium.players[p].el_).css('max-height', $(window).width()*aspectratio);
		} else {
			$(lpcms.premium.players[p].el_).css('max-height', window.innerHeight-68);
		}
	}
};
lpcms.premium.parsePostMedia = function(src) {
	$('.lvrs__postcontent', src).find('video,img').off('contextmenu').on('contextmenu', function(e) {
		e.preventDefault();
		return false;
	}).off('dragstart').on('dragstart', function(e) {
		e.preventDefault();
		return false;
	});
	$('.premium-video', src).each(function(i,v) {
		var options = {
			inactivityTimeout: 2000,
			controlBar: {
				children: [
					'progressControl',
					'playToggle',
					'volumePanel',
					'currentTimeDisplay',
					'durationDisplay',
					'fullscreenToggle',
				]
			}
		};
		var vid = $(v).attr('id');
		if (lpcms.premium.players[vid]) {
			lpcms.premium.players[vid].dispose();
			lpcms.premium.players[vid] = videojs(vid, options);
			var aspectratio = lpcms.premium.players[vid].videoHeight()/lpcms.premium.players[vid].videoWidth();
			if ($(window).width()*aspectratio < (window.innerHeight-68)) {
				$(lpcms.premium.players[vid].el_).css('max-height', $(window).width()*aspectratio);
			} else {
				$(lpcms.premium.players[vid].el_).css('max-height', window.innerHeight-68);
			}
		} else {
			lpcms.premium.players[vid] = videojs(vid, options);
			lpcms.premium.players[vid].on('loadedmetadata', () => {
				var video = videojs(this);
				var aspectratio = video.videoHeight()/video.videoWidth();
				if ($(window).width()*aspectratio < (window.innerHeight-68)) {
					$(video.el_).css('max-height', $(window).width()*aspectratio);
				} else {
					$(video.el_).css('max-height', window.innerHeight-68);
				}
			});
			lpcms.premium.players[vid].on('play', (e) => {
				var slider = $(e.target).parents('.lpcms-slider');
				if (slider.length > 0) {
					slider.find('.lSPager').css('visibility','hidden');
				}
				var post = $(e.target).parents('.lvrs__postcontent');
				if (post.length > 0) {
					$(post).find('.premium-video-duration').hide();
				}
			});
		}
	});
	$('.premium-audio', src).each(function(i,v) {
		var options = {
			controlBar: {
				children: [
					'playToggle',
					'progressControl',
					'remainingTimeDisplay'
				]
			}
		};
		var vid = $(v).attr('id');
		if (lpcms.premium.players[vid]) {
			lpcms.premium.players[vid].dispose();
		}
		lpcms.premium.players[vid] = videojs(vid, options);
		if (!lpcms.premium.hasSubscription) {
			$(lpcms.premium.players[vid].el_).find('button').off('click');
			$(lpcms.premium.players[vid].el_).find('button').on('click', function(e) {
				e.preventDefault();
				lpcms.premium.clicked_but_not_subscribed();
				return false;
			});
		}
	});
}
lpcms.premium.addPostClickHandlers = function(src) {
	$('.lvrs__postcomment__showall', src).off('click').on('click', function() {
		var hidden_comments = $(this).parents('.lvrs__post').find('.lvrs__postcomment.hidden');
		if (hidden_comments.length > 0) {
			hidden_comments.removeClass('hidden');
			$(this).text($(this).data('textvisible'));
		} else {
			$(this).parents('.lvrs__post').find('.lvrs__postcomment:gt(2)').addClass('hidden');
			$(this).text($(this).data('texthidden'));
		}
	});
	$('button.lvrs__sendcomment', src).off('click').on('click', function() {
		var hidden_comments = $(this).parents('.lvrs__post').find('.lvrs__postcomment.hidden');
		if (hidden_comments.length > 0) {
			$(this).parents('.lvrs__post').find('.lvrs__postcomment__showall').trigger('click');
		}
		var clickedbtn = $(this);
		axios.post('/lovers/'+$(this).data('postid')+'/addComment', {
			content: $(this).parent().find('textarea').val()
		}).then((r) => {
			var body = r.data;
			if (body.error) {
				lpcms.alert(body.error);
			} else {
				var datatargets = $('[data-postid='+clickedbtn.data('postid')+']');
				datatargets.data('commentcount', body.commentcount);
				$(clickedbtn).parents('.lvrs__post').find('.lvrs__postinteractives-comments span').text(body.commentcount+' '+(body.commentcount != 1 ? Laravel.lang.common.comments : Laravel.lang.common.comment))
				$('<div class="lvrs__postcomment">').html('<span><b>'+window.Laravel.user.name+'</b> '+Laravel.lang.common.wrote+':</span><p>'+$(clickedbtn).parent().find('textarea').val()+'</p>').insertAfter($(clickedbtn).parents('.lvrs__post').find('.lvrs__postcomment:last'));
				$(clickedbtn).parent().find('textarea').val('');
				$(clickedbtn).parents('.lvrs__post').trigger('focus');
			}
		});
	});
	$('.lvrs__postinteractives-likebtn', src).off('click').on('click', function() {
		lpcms.premium.like_post(this);
	});
};
lpcms.premium.imagesliders = [];
lpcms.premium.clicked_but_not_subscribed = function() {
	lpcms.load_via_ajax('/be-my-lover');
};
lpcms.get_downloaded_vids = () => {
	return new Promise((resolve,reject) => {
		var keys = [];
		if (typeof indexedDB != "undefined") {
			try {
				var request = indexedDB.open("lp-blobdata", 1);
				request.onupgradeneeded = (event) => {
					var db = event.target.result;
					db.createObjectStore("videos", { keyPath: "name" });
				}
				request.onerror = () => { reject(); }
				request.onsuccess = (event) => {
				try {
						var db = event.target.result;

						var transaction = db.transaction(["videos"]);
						var objectStore = transaction.objectStore("videos");
						var keyRequest = objectStore.getAllKeys();
						keyRequest.onerror = () => { reject(); }
						keyRequest.onsuccess = (k) => {
							keys = k.target.result;
							resolve(keys);
						};
					} catch (e) { reject(); }
				}
			} catch (e) { reject(); }
		} else {
			reject();
		}
	});
};
lpcms.cache_offline_videos = (loop) => {
	if (lpcms.is_online) {
		lpcms.get_downloaded_vids().then((vids) => {
			if (vids.length > 0) {
				axios.get('/purchases/videos', {
					params: {
						no_ajax: 'true',
						offlinemode: 'true',
						vids: vids
					}
				}).then((r) => {
					var body = r.data;
					axios.get('https://cdn.leonie-pur.com/css/'+window.Laravel.cacheHash+'/video-js.css');
					axios.get('https://cdn.leonie-pur.com/css/'+window.Laravel.cacheHash+'/videojs.thumbnails.css');
					axios.get('https://cdn.leonie-pur.com/css/'+window.Laravel.cacheHash+'/videojs.airplay.css');
					axios.get('https://cdn.leonie-pur.com/js/'+window.Laravel.cacheHash+'/video.js');
					axios.get('https://cdn.leonie-pur.com/js/'+window.Laravel.cacheHash+'/videojs.thumbnails.js');
					axios.get('https://cdn.leonie-pur.com/js/'+window.Laravel.cacheHash+'/videojs.theaterMode.js');
					axios.get('https://cdn.leonie-pur.com/js/'+window.Laravel.cacheHash+'/silvermine-videojs-quality-selector.min.js');
					axios.get('https://cdn.leonie-pur.com/js/'+window.Laravel.cacheHash+'/videojs.airplay.js');
					$('.medialist__item a', body).not('.medialist__item-category').each((i,a) => {
						axios.get($(a).attr('href'), {
							params: {
								no_ajax: 'true'
							}
						});
					});
				});
			}
		});
	}
	if (loop) {
		setTimeout(function() {
			lpcms.cache_offline_videos(true);
		}, 60000);
	}
};
(function($) {
	if (window.Laravel && window.Laravel.user && window.Laravel.user.authenticated) {
		lpcms.get_accountdata();
		lpcms.cache_offline_videos(true);
	}
})(jQuery);

window.Vue = require('vue');
window.simpleLightbox = require('simplelightbox');
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import VueClickaway from "vue-clickaway";

Vue.directive('clickaway', VueClickaway.directive);
Vue.component('chat-component', require('./components/ChatComponent.vue').default);
Vue.component('chat-messages-component', require('./components/ChatMessagesComponent.vue').default);
Vue.component('chat-message-component', require('./components/ChatMessageComponent.vue').default);
Vue.component('chat-message-attachment-component', require('./components/ChatMessageAttachmentComponent.vue').default);
Vue.component('chat-form-component', require('./components/ChatFormComponent.vue').default);
Vue.component('chat-received-attachments-component', require('./components/ChatReceivedAttachmentsComponent.vue').default);
Vue.component('chat-received-attachment-component', require('./components/ChatReceivedAttachmentComponent.vue').default);
